import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { send2FaCodeForPassword } from '@api/userProfile';

import { TMutateModalHandlers } from '@interfaces/common/handlers';
import { IResponseError } from '@interfaces/errors/apiErrors';
import { IChangePasswordDTO } from '@interfaces/user/dto/userProfileDTO';
import { ISendCodeForChangePasswordWith2Fa } from '@interfaces/user/userProfile';

import { SEND_CODE_2FA_FOR_PASSWORD, USER_PROFILE } from '@constants/queryKeys';

export const useMutateSentPasswordCode = ({
	onSuccess,
	onError,
}: TMutateModalHandlers) => {
	const queryClient = useQueryClient();

	const {
		mutateAsync: sendCode,
		isLoading: isLoadingSendCode,
	} = useMutation<IChangePasswordDTO & ISendCodeForChangePasswordWith2Fa>({
		mutationKey: [SEND_CODE_2FA_FOR_PASSWORD],
		mutationFn: ({
			code,
			newPassword,
			oldPassword,
		}: IChangePasswordDTO & ISendCodeForChangePasswordWith2Fa) => {
			return send2FaCodeForPassword({
				code,
				newPassword,
				oldPassword,
			});
		},
		onSuccess: () => {
			if (onSuccess) onSuccess();

			return [queryClient.invalidateQueries([USER_PROFILE])];
		},
		onError: (err: IResponseError) => {
			if (onError) onError(err);
		},
	});

	return {
		sendCode,
		isLoadingSendCode,
	};
};
